import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./JobAssistant.css";

const API_BASE = process.env.NODE_ENV === "development"
  ? "https://arecah.com/jobassistant/api"
  : "/jobassistant/api";

function JobAssistant() {
  const [jobDescription, setJobDescription] = useState("");
  const [resume, setResume] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResult(null);
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("jobDescription", jobDescription);
      formData.append("resume", resume);

      const response = await fetch(`${API_BASE}/api.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.error) {
        setError(data.error);
        return;
      }

      if (data.choices?.[0]?.message?.content) {
        setResult(data.choices[0].message.content);
      } else {
        setError("Unexpected response format");
      }
    } catch (err) {
      setError(err.message || "Failed to get analysis");
    } finally {
      setLoading(false);
    }
  };

  const bgImage = `${process.env.PUBLIC_URL || ""}/images/jobassistant/background.jpg`;

  return (
    <div className="jobassistant" style={{ backgroundImage: `url(${bgImage})` }}>
      <header className="jobassistant-header">
        <Link to="/" className="back-link">← Arecah</Link>
        <h1>AI Job Assistant</h1>
        <p>Paste a job description and your resume for AI-powered feedback on fit, CV suggestions, and interview prep.</p>
      </header>

      <div className="jobassistant-content">
        <form onSubmit={handleSubmit} className="jobassistant-form">
          <div className="form-group">
            <label htmlFor="jobDescription">Job description</label>
            <textarea
              id="jobDescription"
              value={jobDescription}
              onChange={(e) => setJobDescription(e.target.value)}
              placeholder="Paste the full job description here..."
              rows={6}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="resume">Your resume</label>
            <textarea
              id="resume"
              value={resume}
              onChange={(e) => setResume(e.target.value)}
              placeholder="Paste your resume here..."
              rows={8}
              required
            />
          </div>
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? "Analyzing…" : "Get feedback"}
          </button>
        </form>

        {error && (
          <div className="jobassistant-error">
            {error}
          </div>
        )}

        {result && (
          <div className="jobassistant-result">
            <h2>Analysis</h2>
            <div className="result-content">{result}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default JobAssistant;
